import { useTheme } from "@mui/material";
import { ResponsiveChoropleth } from "@nivo/geo";
import { geoFeatures } from "../data/mockGeoFeatures";
import { tokens } from "../theme";
import { mockGeographyData as data } from "../data/mockData";

const GeographyChart = ({ isDashboard = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <ResponsiveChoropleth
      data={data}
      theme={{
        axis: {
          domain: {
            line: {
              stroke: colors.grey[500], 
            },
          },
          legend: {
            text: {
              fill: colors.grey[300], 
            },
          },
          ticks: {
            line: {
              stroke: colors.grey[500],
              strokeWidth: 1,
            },
            text: {
              fill: colors.grey[300],
            },
          },
        },
        legends: {
          text: {
            fill: colors.grey[300],
          },
        },
      }}
      features={geoFeatures.features}
      margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
      domain={[0, 2000000]} 
      unknownColor="#b0bec5" 
      label="properties.name"
      valueFormat=".0s"
      projectionScale={isDashboard ? 60 : 180} 
      projectionTranslation={isDashboard ? [0.5, 0.55] : [0.52, 0.48]} 
      projectionRotation={[10, -10, 0]} 
      borderWidth={2} 
      borderColor="#ffffff" 
      legends={
        !isDashboard
          ? [
              {
                anchor: "bottom-left",
                direction: "column",
                justify: true,
                translateX: 20,
                translateY: 30, 
                itemsSpacing: 4, 
                itemWidth: 120,
                itemHeight: 20,
                itemDirection: "left-to-right",
                itemTextColor: colors.grey[300], 
                itemOpacity: 0.9,
                symbolSize: 24,
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: colors.primary[500], 
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]
          : undefined
      }
    />
  );
};

export default GeographyChart;
